export function HelpButton({ onClick }) {
  return <button onClick={onClick} className="help-btn">? Help</button>;
}
